import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";

function NuevoPrecioConvenio() {

    const search = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    const id_convenio = new URLSearchParams(search).get('convid');
    const id_producto = new URLSearchParams(search).get('id');
    const nombre_producto = new URLSearchParams(search).get('nomprod');

    const [empresa, setEmpresa] = useState();
    const [convenio, setConvenio] = useState();
    const [producto, setProducto] = useState();
    const [nombreProducto, setNombreProducto] = useState();
    const [nombreConvenio, setNombreConvenio] = useState();
    const [precio, setPrecio] = useState();
    const [precioConvenio, setPrecioConvenio] = useState();

    const [errorlist, setErrorlist] = useState({});
    

    let history = useHistory();

    let userdata = [];
    let clientData = [];
    let rolePermissions = [];


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: id_convenio
            }
        }

        axios.get('convenio',config2)
            .then(response => {
                if (response.status===200) {
                    setEmpresa(response.data[0].nombre_empresa);
                    setNombreConvenio(response.data[0].nombre);
                }
            })
            .catch(error => {
                console.log(error);
            });

        const config3 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: id_producto
            }
        }

        axios.get('lista-precio',config3)
            .then(response => {
                if (response.status===200) {
                    setNombreProducto(response.data[0].nombre);
                    setPrecio(response.data[0].precio);
                }
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            client_id: client.client_id,
            producto_id: id_producto,
            convenio_id: id_convenio,
            precio: precioConvenio
        };

        console.log(conf);
        
        axios.post('precio-convenio', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('nuevo_precio_convenio', JSON.stringify({convenio: nombreConvenio, producto: nombreProducto, precio: precioConvenio}));
                    history.push('lista-precios-convenio');
                }
            )
            .catch(
                err => {
                    setErrorlist(err.response.data);
                    setLoading(false);
                }
            )
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-convenios">Administrar Empresas y Convenios</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/lista-precios-convenio">Listas de Precios</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Asignar precio por convenio</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nuevo Precio por Convenio</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-10">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="role-form" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="empresa">Empresa:</label>
                                                        <p>
                                                        {empresa}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="convenio">Convenio:</label>
                                                        <p>
                                                        {nombreConvenio}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="producto">Producto o Servicio:</label>
                                                        <p>
                                                        {nombreProducto}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label htmlFor="producto">Precio original:</label>
                                                        <p>
                                                        {precio}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="precio_lista">Precio para este convenio:</label>
                                                        <input type="text" name="precio_lista" className="form-control" id="precio_lista" onChange={(e) => setPrecioConvenio(e.target.value)} />
                                                        <div className="invalid-feedback visible">
                                                        {errorlist.precio}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-6">
                                                    <button type="submit" className="btn btn-primary btn-block">
                                                        Guardar&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default NuevoPrecioConvenio;